export default __webpack_public_path__ + "static/media/tech-cloud-bg-2.d5f27d15.jpg";